module.exports = __webpack_public_path__ + "img/server-1.ccc1c0e.png";